/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  users: {
    id: 'app.containers.Dashboard.users',
    defaultMessage: 'Users',
  },
  role: {
    id: 'app.components.UsersByRole.role',
    defaultMessage: 'Roles',
  },
  noMembers: {
    id: 'app.components.UsersByRole.noMembers',
    defaultMessage: 'No members',
  },
  sharedInbox: {
    id: 'app.components.AdminUsers.sharedInbox',
    defaultMessage: 'Shared Inbox',
  },
  removeRole: {
    id: 'app.components.AdminUsers.removeRole',
    defaultMessage: 'Remove Role',
  },
  roleDeleted: {
    id: 'app.components.AdminUsers.roleDeleted',
    defaultMessage: 'The role has been deleted',
  },
  confirmRemoveRole: {
    id: 'app.components.AdminUsers.confirmRemoveRole',
    defaultMessage: "Remove role ''{displayName}''?",
  },
  confirmRemoveMember: {
    id: 'app.components.AdminGroups.confirmRemoveMember',
    defaultMessage: 'Remove member {accountName}?',
  },
  adduser: {
    id: 'app.components.Button.adduser',
    defaultMessage: 'Add User',
  },
  conversations: {
    id: 'app.components.Conversations.conversations',
    defaultMessage: 'Conversations',
  },
  sharedInboxItems: {
    id: 'app.components.AdminUsers.sharedInboxItems',
    defaultMessage: '<ul><li>Users with the same role have a shared inbox which they manage together</li><li>From this inbox, they can start a conversation with all parents and employes in the school</li><li>All parents and employes in the school can choose this inbox when they start a conversation</li></ul>',
  },
  removeRoleModal1: {
    id: 'app.components.AdminUsers.removeRoleModal1',
    defaultMessage: 'Are you sure you want to delete this role? This cannot be undone.',
  },
  removeRoleModal2: {
    id: 'app.components.AdminUsers.removeRoleModal2',
    defaultMessage: 'When you delete the role, the associated inbox is archived:',
  },
  confirmArchiveModalTitle: {
    id: 'app.components.AdminUsers.confirmArchiveModalTitle',
    defaultMessage: 'Archive shared inbox?',
  },
  confirmArchiveModalIntro: {
    id: 'app.components.AdminUsers.confirmArchiveModalIntro',
    defaultMessage: 'When you archive the shared inbox, the following happens:',
  },
  archivedInboxRules: {
    id: 'app.components.AdminUsers.archivedInboxRules',
    defaultMessage: "<ul><li>The inbox is removed from all conversations.</li><li>No more new conversations can be started from the inbox</li><li>Members of ''{displayName}'' can review all conversations to date at their archived inboxes.</li></ul>",
  },
  standardRoleIntro: {
    id: 'app.components.AdminUsers.standardRoleIntro',
    defaultMessage: '"{displayName}" is a standard role, you can not remove it. You may want to change the name if it is named differently at your school.',
  },
  atLeastOneMember: {
    id: 'app.components.AdminUsers.atLeastOneMember',
    defaultMessage: 'There must be at least one member in this role.',
  },
  cannotRemoveSelf: {
    id: 'app.components.AdminUsers.cannotRemoveSelf',
    defaultMessage: 'You cannot remove yourself as member of this role.',
  },
  doArchive: {
    id: 'app.components.AdminUsers.doArchive',
    defaultMessage: 'Archive',
  },
});
